exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "od-star-rating{display:block}od-star-rating .star-label{display:inline-block;width:25px;height:25px;cursor:pointer}od-star-rating .star-label svg{width:25px;height:25px}od-star-rating .star-label+.star-label{margin-left:10px}od-star-rating.small .star-label{width:15px;height:15px}od-star-rating.small .star-label svg{width:15px;height:15px}od-star-rating.small .star-label+.star-label{margin-left:5px}od-star-rating .frozen .star-label{cursor:auto}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/less-loader/lib/loader.js!./javascripts/common/directives/od-star-rating.less
 ** module id = 807
 ** module chunks = 0 1 3 4 5 6
 **/